import React, { useState, useEffect, useMemo } from 'react';
import {
  AdminContentContainer,
  AdminContentTitle,
  NoResults,
  ScrollableList,
  Card,
  CardContent,
  CardText,
  Tabs,
  AdminTab,
} from '../styles';
import { adminGetBookingsDetails } from '../api';
import { Spinner } from ".";

const AppointmentTabs = () => {
  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState('');
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const getNextSevenDays = () => {
    const days = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + i);

      const day = futureDate.getDate().toString().padStart(2, '0');
      const month = (futureDate.getMonth() + 1).toString().padStart(2, '0');

      days.push({ label: `${day}-${month}`, fullDate: `${futureDate.getFullYear()}-${month}-${day}` });
    }

    setSelectedDay(days[0].fullDate); // Seleciona o primeiro dia como padrão

    return days;
  };

  const dayAppointments = useMemo(() => {
    if (!selectedDay || appointments.length === 0) return [];

    const dayObject = appointments.find(
      (item) => Object.prototype.hasOwnProperty.call(item, selectedDay)
    );

    return dayObject ? dayObject[selectedDay] : [];
  }, [appointments, selectedDay]);
  
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await adminGetBookingsDetails();

        if (!response.ok) throw new Error('Erro ao buscar marcações');

        const data = await response.json();

        setAppointments(data);
 
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
    setDays(getNextSevenDays());
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <AdminContentContainer>
      <AdminContentTitle>Histórico de Marcações</AdminContentTitle>

      <Tabs>
        {days.map((day) => (
          <AdminTab
            key={day.fullDate}
            isActive={day.fullDate === selectedDay}
            onClick={() => setSelectedDay(day.fullDate)}
          >
            {day.label}
          </AdminTab>
        ))}
      </Tabs>

      {appointments.length === 0 ? (
        <NoResults>Não há marcações para este dia.</NoResults>
      ) : (
        <ScrollableList>
          {dayAppointments.map((appt) => (
            <Card key={appt.id}>
              <CardContent>
                <CardText><strong>Horário: </strong>{appt.start_time} - {appt.end_time}</CardText>
                <CardText><strong>Nome: </strong> {appt.fullName}</CardText>
                <CardText><strong style={{fontSize: "15px"}}>{appt.invitedUsers.length > 1 ? 'Convidados' : 'Convidado'}: </strong> 
                  {appt.invitedUsers.length > 0 ? appt.invitedUsers.join(', ') : 'Nenhum convidado'}
                </CardText>
                <CardText><strong>Tipo de Reserva: </strong> {appt.type === 'unique' ? 'Avulsa' : 'Mensal'}</CardText>
                <CardText><strong>Status da Reserva: </strong> {appt.status}</CardText>
              </CardContent>
            </Card>
          ))}
        </ScrollableList>
      )}
    </AdminContentContainer>
  );
};

export default AppointmentTabs;
